/**
 * Used to store raw, unfiltered search data responses from searchspring before middleware is processed
 */
let searchData = {};

/**
 * Update the searchData provider variable
 *
 * @param {any} newValue
 */
export const updateSearchDataProvider = newValue => {
	searchData = structuredClone(newValue);
};

export {
	searchData
};
